import React, { useState } from 'react';
import { Modal, Form, Input, App } from 'antd';

import { logger } from '../../services/logger.client';
interface AddEventModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddEvent: (text: string) => Promise<void>;
}

const AddEventModal: React.FC<AddEventModalProps> = ({ isOpen, onClose, onAddEvent }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { message } = App.useApp();

  const handleOk = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      await onAddEvent(values.text);
      message.success(`Event "${values.text}" has been added.`);
      form.resetFields();
      onClose();
    } catch (error: unknown) {
      if (error && typeof error === 'object' && 'info' in error) {
        // Antd form validation error
        return;
      }
      const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred.';
      message.error(`Failed to add event: ${errorMessage}`);
      logger.warn({ formValues: form.getFieldsValue(), errorInfo: error }, 'Add Event failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Add New Event or Rumor"
      open={isOpen}
      confirmLoading={loading}
      onCancel={onClose}
      onOk={handleOk}
      destroyOnHidden
    >
      <Form form={form} layout="vertical" name="add_event_form" onFinish={handleOk}>
        <Form.Item
          name="text"
          label="Event / Rumor Text"
          rules={[{ required: true, message: 'Please input the text for the event!' }]}
        >
          <Input.TextArea rows={4} placeholder="e.g., A caravan from Waterdeep is three days overdue." />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddEventModal;